window.addEventListener('DOMContentLoaded', function () {
    const header = document.querySelector(".header");
    const modalContents = document.querySelectorAll(".c_modal"); 
    const headerHeight = header.offsetHeight;

    modalContents.forEach(modalContent => {
        modalContent.style.height = `calc(100vh - ${headerHeight}px)`;
        modalContent.style.top = `${headerHeight}px`;
    });

    window.addEventListener("scroll", function () {
        const rect = header.getBoundingClientRect();
        const headerBottom = rect.bottom;

        if (headerBottom > 0) {
            modalContents.forEach(modalContent => {
                const topValue = headerBottom;
                const calculatedHeight = `calc(100vh - ${topValue}px)`;
                modalContent.style.height = calculatedHeight;
                modalContent.style.top = `${topValue}px`;
            });

        } else {
            modalContents.forEach(modalContent => {
                modalContent.style.height = "100vh";
                modalContent.style.top = "0";
            });
        }
    });

  //商品詳細ページモーダル
    const productImage = document.querySelector(".product-converter__gallery figure");
    const productImageModal = document.querySelector(".pdp-lightbox");
    productImage.addEventListener('click',function(){
        productImageModal.classList.toggle('pdp-lightbox--open');
        document.body.classList.toggle('no-scroll');
    })

  
});